import clsx from "clsx";
import { Button, Typography } from "@material-ui/core"
import React from "react"
import { makeStyles } from "@material-ui/styles";
import ChevronRightIcon from "@material-ui/icons/ChevronRight";

const useStyles = makeStyles(() => ({
  navigation: {
    paddingTop: 24,
  },
  subheading: {
    margin: 10,
    textAlign: "center",
  },
  bold: {
    fontWeight: 550,
  },
  imgContainer: {
    paddingLeft: 40,
    paddingRight: 40,
    display: "inline-block",
  },
  icon: {
    display: "flex",
  },
  contactUsButtonContainer: {
    textAlign: "center",
    padding: 30,
  },
  container: {
    textAlign: "center",
    display: "inline-block",
  },
  innerContainer: {
    marginBottom: 10,
    display: "inline-block",
  },
  paragraphs: {
    textAlign: "left",
  },
}));

export const CohortsDisabledPage: React.FC = () => {
  const classes = useStyles();

  return (
    <>
      <Typography component="h2" gutterBottom variant="overline">
        Cohorts
      </Typography>
      <Typography component="h1" gutterBottom variant="h3">
        Sync user segments to your destinations.
      </Typography>
      <div className={clsx(classes.container)}>
        <div className={clsx(classes.innerContainer)}>
          <div className={clsx(classes.imgContainer)}>
            <Typography
              className={clsx(classes.subheading)}
              component="h1"
              gutterBottom
              variant="h2"
            >
              How It Works
            </Typography>
          </div>

          <div className={clsx(classes.paragraphs)}>
            <Typography component="p">
              <span className={clsx(classes.bold)}>Step 1:</span> Lorem ipsum
            </Typography>
            <Typography component="p">
              <span className={clsx(classes.bold)}>Step 2:</span> Lorem ipsum
            </Typography>
            <Typography component="p">
              <span className={clsx(classes.bold)}>Step 3:</span> Lorem ipsum
            </Typography>
          </div>
          <div className={clsx(classes.contactUsButtonContainer)}>
            {/* TODO: (jmtaber129): set href to a personas-specific freshpaint email mailto */ }
            <a>
              <Button
                color="primary"
                variant="contained"
              >
                Contact Us
                <ChevronRightIcon className={classes.icon} />
              </Button>
            </a>
          </div>
        </div>
      </div>
    </>
  )
}
